/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { isStringNotEmpty, objectHasPropertyString, isTrue } from "utils/empty-exists";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { defaultOptions } from "cms/components/components/link-button/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import { Logger } from "cms/utils/log/logger";

const LinkButtonItemDisplay = (props) => {

    const { defaultStyle, defaultColour, defaultIcon } = defaultOptions;

    const { token } = useAuth();
    const item = props?.item ?? {};
    const link = item?.link ?? "";
    const style = item?.style ?? defaultStyle;
    const colour = item?.colour ?? defaultColour;
    const icon = item?.icon ?? defaultIcon;

    const [linkData, setLinkData] = useState();
    const internalNewTab = linkData?.new_tab ?? false;
    const isExternal = linkData?.is_external === true;
    const openInNewTab = isExternal || internalNewTab;
    const target = openInNewTab ? "_blank" : "_self";
    const isExternalIcon = icon === "external";
    const isArrowIcon = icon === "arrow";

    useEffect(() => {
        Logger.debug("linkbutton loading");
        // load data if not already populated
        if (!objectHasPropertyString(linkData, "guid")) {
            const loadLink = async () => {
                // check that we have a link url
                if (isStringNotEmpty(link)) {
                    // Logger.debug(`loading link from DB: `, link)
                    const _link = await SimpliCityAdminSDK.link.findOne(token, link);
                    setLinkData(_link);
                }
            };
            loadLink();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link]);

    return (
        <div className='simplicity-linkbutton'>
            <p>
                <a
                    className={`btn icon ${style} ${colour}`}
                    href={linkData?.url}
                    target={target}
                >
                    {linkData?.text}
                    {isTrue(isExternalIcon) &&
                        <span className='link-icon'>
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </span>
                    }
                    {isTrue(isArrowIcon) &&
                        <span className='link-icon'>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                    }
                </a>
            </p>
        </div>
    );
};

LinkButtonItemDisplay.displayName = "LinkButtonItemDisplay";
export { LinkButtonItemDisplay };
